/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateEmployerInviteCommandDto interface.
 */
export function instanceOfCreateEmployerInviteCommandDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    return true;
}
export function CreateEmployerInviteCommandDtoFromJSON(json) {
    return CreateEmployerInviteCommandDtoFromJSONTyped(json, false);
}
export function CreateEmployerInviteCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}
export function CreateEmployerInviteCommandDtoToJSON(json) {
    return CreateEmployerInviteCommandDtoToJSONTyped(json, false);
}
export function CreateEmployerInviteCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}
